import { getEnv } from '../../../utils/runtimeConfig';
import type { PolicyConfig } from './types';

// To update the EULA (for non-technical editors):
//   1. Open frontend/public/legal/eula.md on GitHub.
//   2. Click the pencil icon, edit the markdown (GitHub shows a live preview),
//      commit on a branch, open a PR.
//   3. [Optional] If the title or dates change, update the `header` block below in the same PR.
//   4. Ask a developer to bump the POLICY_VERSION env var on the backend (K8s secret)
//      so existing users are prompted to re-accept.
//
// To move the source elsewhere (e.g. cloud storage):
//   Set REACT_APP_EULA_URL at runtime (via env-config.js / K8s secret).
//   Nothing in this file needs to change.

export const EULA_CONFIG: PolicyConfig = {
  tabLabel: 'EULA',

  header: {
    kicker: 'LEGAL',
    title: 'Reality Coach\nEnd User License Agreement',
    lastUpdated: '3/27/2026',
    uppercase: true,
  },

  contentUrl: getEnv('REACT_APP_EULA_URL') ?? '/legal/eula.md',
};
